module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 045.e14ae84e.jpg";